export const css = {
	root: '_3BariNxB',
	title: '_3RRjDhZm',
	body: 'J3rJs5Tz',
	warning: 'S7Iq9mmY',
	' _key': 'afcpe-theme/afcpe/learning-activity/activity'
};

export default css;
